import { useMemo } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { PanelLeftClose, PanelLeftOpen, Menu } from 'lucide-react';

import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const headerContent = useMemo(() => <HeaderContent />, []);

  const Icon = downLG ? Menu : drawerOpen ? PanelLeftClose : PanelLeftOpen;
  const mainHeader = (
    <Toolbar disableGutters sx={{ minHeight: '64px !important', height: 64, px: { xs: 1.5, sm: 2.5 }, gap: 1 }}>
      <IconButton aria-label="Toggle sidebar" onClick={() => handlerDrawerOpen(!drawerOpen)} size="small" sx={{ color: 'grey.600', mr: 0.5 }}>
        <Icon size={19} strokeWidth={1.6} />
      </IconButton>
      {headerContent}
    </Toolbar>
  );

  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      bgcolor: 'background.paper',
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
      boxShadow: 'none',
      zIndex: 1200,
      width: { xs: '100%', lg: drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)` }
    }
  };

  return !downLG ? (
    <AppBarStyled open={drawerOpen} {...appBar}>
      {mainHeader}
    </AppBarStyled>
  ) : (
    <AppBar {...appBar}>{mainHeader}</AppBar>
  );
}
